import React, { useEffect, useState } from 'react';
import Joi from "joi";
import moment from 'moment';
import { useDispatch } from "react-redux";
import { Dimmer, Loader, Image, Form } from "semantic-ui-react";
import { Button } from "components/atoms/Button/Button";
import { logout } from "actions/authentication";
import { getUserProfile } from "actions/user";
import { Popup } from "controls";
import { formatCurrency } from "controls/utils";
import { useFieldset } from "controls/hooks";
import { SubscriptionLevelTable } from "../../common/SubscriptionLevelTable/SubscriptionLevelTable";
import { ToggleSwitch } from "components/atoms/ToggleSwitch/ToggleSwitch";
import { IncrementalButtonInput } from "components/atoms/IncrementalButtonInput/IncrementalButtonInput";
import { SUBSCRIPTION_OPTIONS, SUBSCRIPTION_VALUES, COUPON_TYPES, tableRows } from "components/Authentication/SignUpForm/types";
import { CardForm } from "components/User/Card/CardForm";
import CouponForm from 'components/CouponForm/CouponForm';
import "components/Authentication/SignUpForm/_SignUpForm.scss";

const renewForm = {
  subscriptionPlan: SUBSCRIPTION_OPTIONS.monthly,
  numberOfSubs: 1,
  coupon: "",
};

const renewSchema = {
  subscriptionPlan: Joi.string().required().label("subscriptionPlan"),
  numberOfSubs: Joi.number().required().label("Number of Credits"),
  coupon: Joi.string().allow(""),
};

const mapData = ({ subscriptionPlan, ...loginData }) => ({
	...loginData,
	subscriptionPlan: SUBSCRIPTION_VALUES[subscriptionPlan][process.env.REACT_APP_ENV],
  });

const RenewSubscription = ({ history }) => {
  const dispatch = useDispatch();
	const [showModal, setShowModal] = useState(false);
	const [userData, setUserData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [profile, setProfile] = useState([]);
	const [discount, setDiscount] = useState({
    type: COUPON_TYPES.percent,
    value: 0
  });

  useEffect(() => {
    const fetchProfile = async () => {
      const profile = await dispatch(getUserProfile());
      if(profile) {
      setProfile(profile);
      setIsLoading(false);
      moment(new Date()).isBefore(profile.subscriptionEnds) && history.push('/');
      } else {
        dispatch(logout());
      }
    };
    fetchProfile();
  }, []);

	const onSubmit = (data) => {
    setShowModal(true);
	setUserData(mapData({ ...data, email: profile. email }));
  }	

  const {
    fields: { subscriptionPlan, numberOfSubs, coupon },
    submit,
    loading,
  } = useFieldset({
    schema: renewSchema,
    source: renewForm,
    onSubmit: onSubmit,
  });
    return (
			<div className="pa2 account">
				{isLoading && 
					<Dimmer active inverted>
					<Loader inverted>Loading Account page</Loader>
					</Dimmer> }
					<div className="flex flex-column h-100 mb2 justify-between items-center account__container relative">
						<a href="https://www.boldreuse.com/">
								<h4 className='account__container--return'>Return to Bold Reuse</h4></a>
						<Image src={process.env.REACT_APP_LOGO} alt='logo' size='small' />
						<h2 className="center account__container--title">My Account</h2>
						<div className="account__container--email">{profile?.email}</div>
						<h3 className="center tc">Select your Subscription type below:</h3>
						<h3 className="center tc">the # of <span className='secondary-color'> credits</span> on your subscription is = to the total # of <span className='secondary-color'>reusables</span> you can have checked out at once</h3>
						<SubscriptionLevelTable />
					</div>
					{showModal &&
						<CardForm 
							message={"This transaction is processed securely using Stripe Billing"}
							title={'Card Information'} 
							userInfo={userData} 
							onCancel={() => setShowModal(!showModal)}
						/>  
					}
					<Form
						className="w-100 center mt3 signUp__form pa3"
						style={{ maxWidth: 500 }}
						onSubmit={submit}
					>
						<Form.Field error={subscriptionPlan.errored}>
							<h3 className="center tc">Your Subscription Term:</h3>
							<Popup
								message="Select a subscription type"
								enabled={subscriptionPlan.errored}
							>
								<ToggleSwitch
									onChange={subscriptionPlan.onChange}
									value={subscriptionPlan.value}
									optionA={SUBSCRIPTION_OPTIONS.monthly}
									optionB={SUBSCRIPTION_OPTIONS.annual}
								/>
							</Popup>
						</Form.Field>
						<Form.Field error={numberOfSubs.errored}>
							<h3 className="center tc f4">Number of credits</h3>
							<IncrementalButtonInput
								value={numberOfSubs.value}
								onChange={numberOfSubs.onChange}
								min={1}
								max={subscriptionPlan.value === SUBSCRIPTION_OPTIONS.monthly ? 2 : 4}
							/>
						</Form.Field>
						<h3 className='tc'>
							Total cost: 
							<span className='secondary-color f3 fw5'> 
								{
									formatCurrency(discount.type !== COUPON_TYPES.price ?

									tableRows[numberOfSubs.value || 1][subscriptionPlan.value === SUBSCRIPTION_OPTIONS.monthly ? 1 : 2 ]?.value * (subscriptionPlan.value === SUBSCRIPTION_OPTIONS.annual ? 1 - discount.value : 1) 

									: tableRows[numberOfSubs.value || 1][subscriptionPlan.value === SUBSCRIPTION_OPTIONS.monthly ? 1 : 2 ]?.value - (subscriptionPlan.value === SUBSCRIPTION_OPTIONS.annual ? discount.value : 0 )
									)
									}
									/{subscriptionPlan.value === SUBSCRIPTION_OPTIONS.monthly ? 'month' : 'year'}
							</span>
						</h3>
						<CouponForm setDiscount={setDiscount} value={coupon.value} onChange={coupon.onChange} discount={discount} subscriptionPlan={subscriptionPlan.value} />
        		<Button text="Next" disabled={loading} onClick={submit} extraStyle='flex center ph5' />
					</Form>
			</div>
  );
};

export default RenewSubscription
